/* ============================================================
   SSS Boutique — theme.js
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', maximumFractionDigits: 0
      }).format((cents || 0) / 100);
    } catch (e) {
      return '₹' + Math.round((cents || 0) / 100);
    }
  };

  /* ---------- Announcement bar (slide type) ----------
     Same rotate-one-at-a-time pattern as the hero slideshow below, just
     lighter: no dots, cross-fade handled by the .is-active CSS toggle. */
  $$('[data-announcement-slide]').forEach((root) => {
    const items = $$('[data-announcement-item]', root);
    if (items.length < 2) return;
    let idx = Math.max(0, items.findIndex((s) => s.classList.contains('is-active')));
    const show = (n) => {
      idx = (n + items.length) % items.length;
      items.forEach((el, i) => el.classList.toggle('is-active', i === idx));
    };
    const seconds = parseFloat(root.getAttribute('data-autoplay'));
    const interval = isNaN(seconds) ? 4000 : seconds * 1000;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    const start = () => { if (interval > 0 && !reduced && !timer) timer = setInterval(() => show(idx + 1), interval); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  });

  /* ---------- Mobile navigation ---------- */
  const mobileNav = $('[data-mobile-nav]');
  const mobileOverlay = $('[data-mobile-overlay]');
  const openMobile = () => { mobileNav && mobileNav.classList.add('is-open'); mobileOverlay && mobileOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const closeMobile = () => { mobileNav && mobileNav.classList.remove('is-open'); mobileOverlay && mobileOverlay.classList.remove('is-open'); document.body.style.overflow = ''; };
  $$('[data-mobile-open]').forEach(b => b.addEventListener('click', openMobile));
  $$('[data-mobile-close]').forEach(b => b.addEventListener('click', closeMobile));
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  /* ---------- Search overlay ---------- */
  const searchOverlay = $('[data-search-overlay]');
  $$('[data-search-open]').forEach(b => b.addEventListener('click', () => {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    const input = $('input', searchOverlay);
    input && input.focus();
  }));
  const closeSearch = () => searchOverlay && searchOverlay.classList.remove('is-open');
  searchOverlay && searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) closeSearch();
  });
  $$('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); closeMobile(); }
  });

  /* ---------- Footer accordion (mobile) ---------- */
  $$('[data-footer-acc]').forEach(btn => {
    btn.addEventListener('click', () => btn.closest('.footer__col').classList.toggle('is-open'));
  });

  /* ---------- Generic accordion (PDP) ---------- */
  $$('[data-accordion]').forEach(btn => {
    btn.addEventListener('click', () => btn.closest('.accordion__item').classList.toggle('is-open'));
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-slideshow]').forEach((root) => {
    const slides = $$('[data-slide]', root);
    const dots = $$('[data-dot]', root);
    if (slides.length < 2) return;
    let idx = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    const show = (n) => {
      idx = (n + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    };
    dots.forEach((d, i) => d.addEventListener('click', () => { show(i); resetAutoplay(); }));

    // Autoplay interval comes from the section setting (seconds, 0 = off).
    const seconds = parseFloat(root.getAttribute('data-autoplay'));
    const interval = isNaN(seconds) ? 5000 : seconds * 1000;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    const start = () => { if (interval > 0 && !reduced && !timer) timer = setInterval(() => show(idx + 1), interval); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const resetAutoplay = () => { stop(); start(); };
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  });

  /* ---------- Horizontal scroll-snap carousels ----------
     Shared by "Shop by reels" and the Testimonials carousel -- both use
     the same [data-reels] / [data-reels-track] / [data-reels-prev] /
     [data-reels-next] markup, so one handler drives both. Reads the
     first card's own width + the track's gap rather than assuming a
     fixed card class, so it works for .reel and .testimonial alike. */
  $$('[data-reels]').forEach((wrap) => {
    const track = $('[data-reels-track]', wrap);
    const prev = $('[data-reels-prev]', wrap);
    const next = $('[data-reels-next]', wrap);
    if (!track) return;
    const scrollByCard = (dir) => {
      const card = track.firstElementChild;
      const gapStr = getComputedStyle(track).columnGap || getComputedStyle(track).gap;
      const gap = parseFloat(gapStr) || 14;
      const amount = card ? card.getBoundingClientRect().width + gap : 220;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };
    prev && prev.addEventListener('click', () => scrollByCard(-1));
    next && next.addEventListener('click', () => scrollByCard(1));
  });

  /* ---------- Quantity steppers (generic, non-cart) ---------- */
  $$('[data-qty]').forEach(stepper => {
    const input = $('[data-qty-input]', stepper) || $('input', stepper);
    const minus = $('[data-qty-minus]', stepper);
    const plus = $('[data-qty-plus]', stepper);
    if (!input || input.hasAttribute('data-cart-qty')) return; // cart handled separately
    minus && minus.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    plus && plus.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------- Collection: sort ---------- */
  const applySort = (sel) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  };
  const sortSel = $('[data-sort]');
  sortSel && sortSel.addEventListener('change', () => applySort(sortSel));
  const searchSort = $('[data-search-sort]');
  searchSort && searchSort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', searchSort.value);
    window.location.href = url.toString();
  });

  /* ---------- Collection: facets ---------- */
  $('[data-filter-open]') && $('[data-filter-open]').addEventListener('click', () => {
    const f = $('[data-facets]');
    f && f.classList.toggle('is-open');
  });
  $$('[data-facet-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const facet = btn.closest('.facet');
      facet.classList.toggle('is-collapsed');
      $$('.facet__item, .swatch-row, .price-range', facet).forEach(el => {
        el.style.display = facet.classList.contains('is-collapsed') ? 'none' : '';
      });
    });
  });
  $$('[data-facet-more]').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.facet__hidden', btn.closest('.facet')).forEach(el => el.style.display = 'flex');
      btn.style.display = 'none';
    });
  });
  // color swatch visual state
  $$('.swatch input[type="checkbox"]').forEach(cb => {
    if (cb.checked) cb.closest('.swatch').style.outline = '2px solid var(--brand)';
    cb.addEventListener('change', () => {
      cb.closest('.swatch').style.outline = cb.checked ? '2px solid var(--brand)' : 'none';
    });
  });

  /* ============================================================
     PRODUCT PAGE — variant selection + gallery
     ============================================================ */
  (function initProduct() {
    const root = $('[data-product-info]');
    if (!root) return;
    let variants = [];
    try { variants = JSON.parse($('[data-variants]').textContent); } catch (e) {}

    const form = $('#product-form') || $('[id^="product-form"]');
    const idInput = $('[data-variant-id]');
    const priceWrap = $('.pdp__price');
    const addBtn = $('[data-add-to-cart]');
    const addText = $('[data-add-text]');
    const buyBtn = $('[data-buy-now]');
    const colorValueEl = $('[data-color-value]');

    // Each option group carries data-option-index (1-based Shopify option
    // position). Selecting on the attribute rather than on .opt-colors/.opt-sizes
    // means a third option (Fabric, Length, ...) participates too.
    const optionGroups = $$('[data-option-index]');

    const matchVariant = () => {
      const selected = [];
      optionGroups.forEach(g => {
        const idx = parseInt(g.getAttribute('data-option-index'), 10) - 1;
        const a = $('.is-active', g);
        if (a && idx >= 0) selected[idx] = a.getAttribute('data-option-value');
      });
      const matches = variants.filter(v =>
        selected.every((val, i) => val == null || v.options[i] === val)
      );
      return matches.find(v => v.available) || matches[0];
    };

    const updatePrice = (v) => {
      if (!priceWrap || !v) return;
      let html = '<span class="price__current">' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        html += ' <span class="price__compare">' + money(v.compare_at_price) + '</span>';
        html += ' <span class="price__save">(' + pct + '% OFF)</span>';
      }
      priceWrap.innerHTML = html;
    };

    const updateImage = (v) => {
      if (!v) return;
      const img = $('[data-main-img]');
      let src = null;
      if (v.featured_image && v.featured_image.src) src = v.featured_image.src;
      else if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) src = v.featured_media.preview_image.src;
      if (img && src) img.src = src.indexOf('width=') === -1 ? src : src;
    };

    const updateAvailability = (v) => {
      const available = !!(v && v.available);
      [addBtn, buyBtn].forEach(b => { if (b) b.disabled = !available; });
      if (addText) {
        addText.textContent = available
          ? (addText.getAttribute('data-avail') || 'Add to Cart')
          : (addText.getAttribute('data-sold-out') || 'Sold Out');
      }
    };

    /* Grey out any option value that has no available variant, given the
       current selection in the *other* option groups. */
    const updateSizeAvailability = () => {
      optionGroups.forEach(group => {
        const idx = parseInt(group.getAttribute('data-option-index'), 10) - 1;
        if (idx < 0) return;

        // What is selected in every group other than this one.
        const others = [];
        optionGroups.forEach(g => {
          if (g === group) return;
          const i = parseInt(g.getAttribute('data-option-index'), 10) - 1;
          const a = $('.is-active', g);
          if (a && i >= 0) others.push([i, a.getAttribute('data-option-value')]);
        });

        $$('.opt-size, .opt-color', group).forEach(btn => {
          const val = btn.getAttribute('data-option-value');
          const exists = variants.some(v =>
            v.available &&
            v.options[idx] === val &&
            others.every(([i, o]) => v.options[i] === o)
          );
          btn.classList.toggle('is-out', !exists);
        });
      });
    };

    const onSelect = () => {
      updateSizeAvailability();
      const v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      updatePrice(v);
      updateImage(v);
      updateAvailability(v);
      if (colorValueEl) {
        const activeColor = $('.opt-colors .is-active');
        if (activeColor) colorValueEl.textContent = activeColor.getAttribute('data-option-value');
      }
    };

    $$('.opt-color, .opt-size').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-out')) return;
        const group = btn.parentElement;
        $$('.is-active', group).forEach(x => x.classList.remove('is-active'));
        btn.classList.add('is-active');
        onSelect();
      });
    });

    // Thumbnail gallery
    const mainImg = $('[data-main-img]');
    $$('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        $$('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = $('img', thumb).src;
        if (mainImg) mainImg.src = src.replace(/width=\d+/, 'width=900').replace(/_\d+x\d+/, '');
      });
    });

    // PDP qty stepper
    const qtyInput = $('[data-qty-input]', root);
    const qMinus = $('[data-qty-minus]', root);
    const qPlus = $('[data-qty-plus]', root);
    qMinus && qMinus.addEventListener('click', () => { if (qtyInput) qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    qPlus && qPlus.addEventListener('click', () => { if (qtyInput) qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    // Initial availability pass
    updateSizeAvailability();
    // Buy Now: allow native submit with name=checkout (Shopify handles)
  })();

  /* ============================================================
     CUSTOMER ADDRESSES
     Panel toggling, delete, and country -> province linking. The province
     lists come straight off the data-provinces attribute that
     `country_option_tags` renders, so no external Shopify script is needed.
     ============================================================ */
  (function initAddresses() {
    if (!$('[data-address-country]') && !$('[data-address-toggle]')) return;

    $$('[data-address-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const panel = document.getElementById(btn.getAttribute('data-address-toggle'));
        if (!panel) return;
        panel.hidden = !panel.hidden;
        if (!panel.hidden) {
          const field = $('input, select', panel);
          field && field.focus();
        }
      });
    });

    $$('[data-address-delete]').forEach(btn => {
      btn.addEventListener('click', () => {
        const url = btn.getAttribute('data-target');
        if (!url) return;
        if (!window.confirm(btn.getAttribute('data-confirm') || 'Delete this address?')) return;
        const form = document.createElement('form');
        form.method = 'post';
        form.action = url;
        form.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(form);
        form.submit();
      });
    });

    const fillProvinces = (countrySelect) => {
      const target = document.getElementById(countrySelect.getAttribute('data-province-target'));
      if (!target) return;
      const wrapper = target.closest('[data-province-wrapper]');
      const option = countrySelect.options[countrySelect.selectedIndex];

      let provinces = [];
      try { provinces = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (e) {}

      target.innerHTML = '';
      if (!provinces.length) {
        if (wrapper) wrapper.hidden = true;
        return;
      }
      if (wrapper) wrapper.hidden = false;

      const preselect = target.getAttribute('data-default');
      provinces.forEach(pair => {
        const opt = document.createElement('option');
        opt.value = pair[0];
        opt.textContent = pair[1];
        if (preselect && preselect === pair[0]) opt.selected = true;
        target.appendChild(opt);
      });
    };

    $$('[data-address-country]').forEach(select => {
      const preselect = select.getAttribute('data-default');
      if (preselect) select.value = preselect;
      fillProvinces(select);
      select.addEventListener('change', () => {
        // A fresh country invalidates any previously chosen province.
        const target = document.getElementById(select.getAttribute('data-province-target'));
        if (target) target.removeAttribute('data-default');
        fillProvinces(select);
      });
    });
  })();

  /* ============================================================
     PRODUCT RECOMMENDATIONS
     `recommendations.products` is only populated when the section is
     rendered through the Product Recommendations API, so on a normal page
     load the section renders its fallback and we swap in the real results.
     ============================================================ */
  (function initRecommendations() {
    const root = $('[data-recommendations]');
    if (!root) return;
    const productId = root.getAttribute('data-product-id');
    const sectionId = root.getAttribute('data-section-id');
    if (!productId || !sectionId) return;

    const url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
                '&product_id=' + encodeURIComponent(productId) +
                '&limit=' + encodeURIComponent(root.getAttribute('data-limit') || 4);

    fetch(url)
      .then(r => (r.ok ? r.text() : Promise.reject(r.status)))
      .then(html => {
        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-recommendations] .product-grid');
        const grid = $('.product-grid', root);
        if (fresh && grid && fresh.children.length) {
          grid.innerHTML = fresh.innerHTML;
          // Newly injected cards need their wishlist hearts wired up.
          document.dispatchEvent(new CustomEvent('theme:cards-added'));
        }
      })
      .catch(() => { /* keep the fallback grid */ });
  })();

  /* ============================================================
     CART DRAWER + CART — AJAX quantity, remove, add-to-cart, and the
     slide-out drawer itself.

     Delegated listeners throughout (document.addEventListener with
     .closest(), not per-element .forEach) because the drawer's row
     markup is swapped in wholesale after every mutation (Shopify's
     Section Rendering API re-renders sections/cart-drawer.liquid) and
     the same data-cart-qty/plus/minus/remove attributes are reused by
     both the drawer and the full cart page -- a listener bound once at
     load time would go stale the moment the drawer's HTML is replaced.
     ============================================================ */
  (function initCart() {
    const drawerContainer = $('[data-cart-drawer-container]');
    const getDrawer = () => $('[data-cart-drawer]');
    const getOverlay = () => $('[data-cart-drawer-overlay]');

    const openDrawer = () => {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.classList.add('is-open');
      const overlay = getOverlay();
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    const closeDrawer = () => {
      const drawer = getDrawer();
      const overlay = getOverlay();
      drawer && drawer.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    // Swap freshly-rendered drawer HTML (from a cart/add.js or
    // cart/change.js response's `sections['cart-drawer']`) into the
    // container, re-opening it afterwards if it was already open.
    const updateDrawerSection = (html, keepOpen) => {
      if (!drawerContainer || !html) return;
      drawerContainer.innerHTML = html;
      if (keepOpen) openDrawer();
    };

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-drawer-close]')) { closeDrawer(); return; }
      if (e.target === getOverlay()) { closeDrawer(); return; }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    const refreshTotals = (cart) => {
      $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const subtotalRow = $('.order-summary__rows .order-summary__row:first-child span:last-child');
      if (subtotalRow) subtotalRow.textContent = money(cart.items_subtotal_price);
      const totalEl = $('.order-summary__total .amount');
      if (totalEl) totalEl.textContent = money(cart.total_price);

      // Multiple bars can be on the page at once (cart page + drawer),
      // so update every one rather than just the first match.
      $$('[data-shipping-progress]').forEach((bar) => {
        const threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10) || 0;
        if (threshold <= 0) return;
        const unlocked = cart.total_price >= threshold;
        const pct = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));
        const fill = $('[data-shipping-progress-fill]', bar);
        const msg = $('[data-shipping-progress-msg]', bar);
        if (fill) fill.style.width = pct + '%';
        bar.classList.toggle('shipping-progress--complete', unlocked);
        if (msg) {
          msg.textContent = unlocked
            ? bar.getAttribute('data-unlocked-text')
            : (bar.getAttribute('data-remaining-template') || '').replace('__AMOUNT__', money(threshold - cart.total_price));
        }
      });

      // Only the full cart page reloads itself out from under an empty
      // cart -- the drawer just re-renders its own empty state via the
      // section swap, wherever the visitor happens to be browsing.
      if (cart.item_count === 0 && $('[data-cart-form]')) window.location.reload();
    };

    const changeQty = (key, qty) => {
      const wasOpen = !!(getDrawer() && getDrawer().classList.contains('is-open'));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer' })
      })
        .then(r => r.json())
        .then(cart => {
          const row = $('[data-cart-row][data-key="' + key + '"]');
          const line = cart.items.find(i => i.key === key);
          if (!line && row) row.remove();
          if (line && row) {
            const subtotalCell = $$('td', row)[5];
            if (subtotalCell) {
              const n = $('.now', subtotalCell);
              if (n) n.textContent = money(line.original_line_price);
            }
          }
          refreshTotals(cart);
          if (cart.sections && cart.sections['cart-drawer']) {
            updateDrawerSection(cart.sections['cart-drawer'], wasOpen);
          }
        })
        .catch(() => window.location.reload());
    };

    let debounce;
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      clearTimeout(debounce);
      const key = input.getAttribute('data-key');
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      debounce = setTimeout(() => changeQty(key, qty), 250);
    });

    document.addEventListener('click', (e) => {
      const plus = e.target.closest('[data-cart-plus]');
      if (plus) {
        const key = plus.getAttribute('data-key');
        const input = $('[data-cart-qty][data-key="' + key + '"]');
        if (!input) return;
        input.value = (parseInt(input.value, 10) || 0) + 1;
        changeQty(key, parseInt(input.value, 10));
        return;
      }
      const minus = e.target.closest('[data-cart-minus]');
      if (minus) {
        const key = minus.getAttribute('data-key');
        const input = $('[data-cart-qty][data-key="' + key + '"]');
        if (!input) return;
        const q = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        input.value = q;
        changeQty(key, q);
        return;
      }
      const remove = e.target.closest('[data-cart-remove]');
      if (remove) { changeQty(remove.getAttribute('data-key'), 0); }
    });

    /* ---- Add to cart (AJAX, opens the drawer) ----
       Only the "Add to Cart" submit (name=add) is intercepted -- "Buy
       Now" (name=checkout) is left to submit natively straight to
       checkout, using e.submitter to tell the two apart regardless of
       which button on the PDP form was actually pressed. */
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.matches || !form.matches('#product-form, [id^="product-form"]')) return;
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'add') return; // Buy Now / no submitter: native submit
      e.preventDefault();
      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      submitter.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json().then(data => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          submitter.disabled = false;
          if (!ok) {
            window.alert(data.description || data.message || 'Could not add to cart.');
            return;
          }
          if (data.sections && data.sections['cart-drawer']) {
            updateDrawerSection(data.sections['cart-drawer'], true);
          }
          fetch('/cart.js').then(r => r.json()).then(refreshTotals);
          openDrawer();
        })
        .catch(() => { submitter.disabled = false; form.submit(); });
    });
  })();

})();